function bindModals() {
  document.querySelectorAll('[data-modal-open]').forEach((trigger) => {
    if (trigger.dataset.mxModalBound) return;
    const dialog = document.getElementById(trigger.dataset.modalOpen);
    if (!dialog) return;
    trigger.dataset.mxModalBound = '1';
    trigger.addEventListener('click', () => {
      dialog.showModal();
      document.documentElement.classList.add('scroll-lock');
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-modal-close]')) dialog.close();
    });
    dialog.addEventListener('close', () => document.documentElement.classList.remove('scroll-lock'));

    // showModal() promotes the dialog to the top layer, and Shop Pay renders its
    // "sample plans" sheet outside this element — no z-index can lift it above.
    // Step our dialog aside once Shop Pay's own click handler has run.
    const shopPayRow = dialog.querySelector('[data-shoppay-row]');
    if (shopPayRow) {
      shopPayRow.addEventListener('click', () => {
        setTimeout(() => {
          if (dialog.open) dialog.close();
        }, 0);
      });
    }
  });
}
bindModals();

let lastCents = 0;
let priceDebounce = null;

function readDisplayedCents(root) {
  const currentEl = root.querySelector('.price__current');
  if (!currentEl) return 0;
  return Math.round(parseFloat(currentEl.textContent.replace(/[^0-9.]/g, '')) * 100) || 0;
}

function formatMoney(cents) {
  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
    }).format(cents / 100);
  } catch (e) {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
  }
}

const AFTERPAY_PLACEMENT_SEL = 'afterpay-placement, square-placement';
let afterpayTimer = null;

function afterpayAnchor() {
  return document.querySelector('.financing-row__afterpay .price__container-afterpay');
}

function afterpayRendered() {
  const anchor = afterpayAnchor();
  return !!(anchor && anchor.parentElement && anchor.parentElement.querySelector(AFTERPAY_PLACEMENT_SEL));
}

function dedupeAfterpayPlacements() {
  const placements = document.querySelectorAll(AFTERPAY_PLACEMENT_SEL);
  if (placements.length <= 1) return;
  const anchor = afterpayAnchor();
  let keep = anchor && anchor.parentElement ? anchor.parentElement.querySelector(AFTERPAY_PLACEMENT_SEL) : null;
  if (!keep) keep = placements[0];
  placements.forEach((placement) => {
    if (placement !== keep) placement.remove();
  });
}

function rerenderAfterpay(cents) {
  if (!window.afterpay_current_variant) return;
  const changed = window.afterpay_current_variant.price !== cents;
  window.afterpay_current_variant.price = cents;

  if (!changed && afterpayRendered()) return;

  clearTimeout(afterpayTimer);
  afterpayTimer = setTimeout(() => {
    if (!window.Afterpay || typeof window.Afterpay.init !== 'function') return;
    const $ = window.jQuery || window.$;
    if (!$) return;
    document.querySelectorAll(AFTERPAY_PLACEMENT_SEL).forEach((placement) => placement.remove());
    try {
      window.Afterpay.init($);
    } catch (e) {
    }
    dedupeAfterpayPlacements();
    revealAfterpayRow();
  }, 250);
}

function revealAfterpayRow() {
  const row = document.querySelector('[data-afterpay-row]');
  if (row && row.hidden && afterpayRendered()) row.hidden = false;
}

function watchAfterpayBoot() {
  if (!afterpayAnchor()) return;

  const row = document.querySelector('[data-afterpay-row]');
  if (row && !row.dataset.mxAfterpayWatched) {
    row.dataset.mxAfterpayWatched = '1';
    new MutationObserver(() => {
      dedupeAfterpayPlacements();
      revealAfterpayRow();
    }).observe(row, { childList: true, subtree: true });
  }

  let tries = 0;
  const timer = setInterval(() => {
    dedupeAfterpayPlacements();
    revealAfterpayRow();
    if (afterpayRendered()) {
      if (lastCents && window.afterpay_current_variant && window.afterpay_current_variant.price !== lastCents) {
        rerenderAfterpay(lastCents);
      }
      clearInterval(timer);
      return;
    }
    if (++tries >= 12) clearInterval(timer);
  }, 250);
}

function parseMoneyCents(text) {
  const match = String(text || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
  return match ? Math.round(parseFloat(match[1]) * 100) : 0;
}

function selectedAddon() {
  const chosen = document.querySelectorAll('[name^="mw_opts"]:checked, select[name^="mw_opts"] option:checked');
  let total = 0;
  let counted = 0;
  chosen.forEach((node) => {
    const isOption = node.tagName === 'OPTION';
    const row = node.closest('[data-value-id]') || node.closest('.mw-option__value');
    const priceEl = row ? row.querySelector('.mw-option__price') : null;

    if (priceEl) {
      if (!/\d/.test(priceEl.textContent)) return;
      total += parseMoneyCents(priceEl.textContent);
      counted += 1;
      return;
    }

    if (isOption) {
      total += parseMoneyCents(node.textContent);
      counted += 1;
      return;
    }

    if (row) counted += 1;
  });
  return { total, counted, selected: chosen.length };
}

function normalizeHero(root) {
  const priceEl = root.querySelector('.price');
  const currentEl = root.querySelector('.price__current');
  if (!priceEl || !currentEl) return;

  const poleListed = parseInt(priceEl.dataset.variantPrice, 10) || 0;
  if (!poleListed) return;

  const off = parseFloat(priceEl.dataset.offPercent) || 0;
  const remainder = off > 0 && off < 100 ? 100 - off : 100;

  const written = readDisplayedCents(root);
  if (!written) return;

  const addonInfo = selectedAddon();
  const addon =
    addonInfo.counted === addonInfo.selected
      ? addonInfo.total
      : Math.max(0, written - poleListed);

  const hero = Math.floor((poleListed * remainder) / 100) + addon;
  if (hero === written) return;
  currentEl.textContent = formatMoney(hero);
}

function syncFinancingAmount(force) {
  const root = document.querySelector('[id^="Price-"]');
  if (!root) return;
  normalizeHero(root);
  const cents = readDisplayedCents(root);
  if (!cents) return;
  if (cents === lastCents && !force) return;
  lastCents = cents;

  const priceEl = root.querySelector('.price');
  const baseCents = priceEl ? parseInt(priceEl.dataset.base, 10) || 0 : 0;
  const baseCompareCents = priceEl ? parseInt(priceEl.dataset.compare, 10) || 0 : 0;
  const addonDelta = baseCents && cents > baseCents ? cents - baseCents : 0;
  const compareCents = baseCompareCents > 0 ? baseCompareCents + addonDelta : 0;

  const compareEl = root.querySelector('.price__compare');
  if (compareEl && compareCents > 0) {
    const compareText = compareEl.querySelector('.price-item') || compareEl;
    compareText.textContent = formatMoney(compareCents);
  }

  const badge = root.querySelector('.badge--sale');
  if (compareEl && badge) {
    if (compareCents > cents) {
      const pct = Math.round(((compareCents - cents) / compareCents) * 100);
      badge.textContent = `${pct}% Off · Save ${formatMoney(compareCents - cents)}`;
      badge.hidden = false;
    } else {
      badge.hidden = true;
    }
  }

  const trigger = document.querySelector('[data-financing-min]');
  if (trigger) trigger.hidden = cents < (parseInt(trigger.dataset.financingMin, 10) || 0);

  const klarna = document.querySelector('klarna-placement[data-purchase-amount]');
  if (klarna && (force || klarna.getAttribute('data-purchase-amount') !== String(cents))) {
    klarna.setAttribute('data-purchase-amount', String(cents));
    refreshKlarna();
  }

  const dollars = cents / 100;
  const approve = document.querySelector('.embedded_approve');
  if (approve) {
    approve.setAttribute('approve-price', dollars);
    const teaser = approve.querySelector('[approve-function="teaser_rate"]');
    if (teaser) teaser.setAttribute('approve-total', dollars);
  }
  const clicklease = document.querySelector('.clicklease-mount');
  if (clicklease) clicklease.setAttribute('data-amount', dollars);

  rerenderAfterpay(cents);

  if (window.MX) window.MX.publish('price:total', cents);
}

let klarnaTimer = null;
function refreshKlarna() {
  clearTimeout(klarnaTimer);
  klarnaTimer = setTimeout(() => {
    try {
      if (window.Klarna && window.Klarna.OnsiteMessaging && window.Klarna.OnsiteMessaging.refresh) {
        window.Klarna.OnsiteMessaging.refresh();
      }
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    } catch (e) {
    }
  }, 120);
}

function rekickMageworxAddon() {
  const checked = document.querySelector('[name^="mw_opts"]:checked');
  if (!checked) return;
  try {
    checked.checked = false;
    checked.dispatchEvent(new Event('change', { bubbles: true }));
    checked.checked = true;
    checked.dispatchEvent(new Event('click', { bubbles: true }));
    checked.dispatchEvent(new Event('change', { bubbles: true }));
  } catch (e) {
  }
}

function bindPriceObserver() {
  const root = document.querySelector('[id^="Price-"]');
  if (!root || root.dataset.mxPriceBound) return;
  root.dataset.mxPriceBound = '1';
  new MutationObserver(() => {
    clearTimeout(priceDebounce);
    priceDebounce = setTimeout(() => syncFinancingAmount(false), 250);
  }).observe(root, { subtree: true, childList: true, characterData: true });
  syncFinancingAmount(true);
  watchAfterpayBoot();
}
bindPriceObserver();

document.addEventListener('change', (event) => {
  const target = event.target;
  if (target && target.name && target.name.indexOf('mw_opts') === 0) {
    syncFinancingAmount(true);
    tidyApoCardPrices();
  }
});

function tidyApoCardPrices() {
  if (!document.body.classList.contains('template-variant-specs-first')) return;
  document.querySelectorAll('.mw-option__price').forEach((el) => {
    const next = el.textContent.replace(/[()]/g, '').replace(/\s+/g, ' ').trim();
    if (next && next !== el.textContent.trim()) el.textContent = next;
  });
}

function selectFirstApoOption() {
  if (!document.body.classList.contains('template-variant-specs-first')) return;
  document.querySelectorAll('.product__info .mw-option--type-button, .product__info .mw-option--button-style-version-1').forEach((option) => {
    const inputs = option.querySelectorAll('.mw-option__control');
    if (!inputs.length) return;
    if (option.querySelector('.mw-option__value--selected')) return;
    for (let i = 0; i < inputs.length; i += 1) {
      if (inputs[i].checked) return;
    }
    inputs[0].click();
  });
}

selectFirstApoOption();
setTimeout(selectFirstApoOption, 250);

if (window.MX) {
  window.MX.subscribe('apo:init', () => {
    bindPriceObserver();
    syncFinancingAmount(true);
    tidyApoCardPrices();
    selectFirstApoOption();
    setTimeout(selectFirstApoOption, 150);
  });

  window.MX.subscribe('variant:refresh', () => {
    setTimeout(() => {
      rekickMageworxAddon();
      syncFinancingAmount(true);
      watchAfterpayBoot();
      tidyApoCardPrices();
      selectFirstApoOption();
    }, 80);
  });
}

document.addEventListener('shopify:section:load', () => {
  bindModals();
  bindPriceObserver();
});

document.addEventListener('mx:sale-expired', () => syncFinancingAmount(true));

class DeliveryEstimate extends HTMLElement {
  connectedCallback() {
    // No ship date for sold-out or pre-order variants (the Liquid sets the first state).
    if (window.MX) {
      const preorderIds = (this.dataset.preorderIds || '').split(',').filter(Boolean);
      window.MX.subscribe('variant:change', (variant) => {
        if (!variant) return;
        this.hidden = !variant.available || preorderIds.indexOf(String(variant.id)) !== -1;
      });
    }

    this.select = this.querySelector('[data-state-select]');
    if (!this.select) return;
    this.cutoffHour = parseInt(this.dataset.cutoffHour, 10) || 13;

    try {
      const saved = localStorage.getItem('mx:delivery-state');
      if (saved) {
        const match = Array.from(this.select.options).find((option) => option.textContent === saved);
        if (match) match.selected = true;
      }
    } catch (e) {
    }

    this.select.addEventListener('change', () => {
      try {
        localStorage.setItem('mx:delivery-state', this.select.options[this.select.selectedIndex].textContent);
      } catch (e) {
      }
      this.render();
    });

    this.render();
  }

  nowET() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
  }

  fmt(date) {
    return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  addBusinessDays(start, days) {
    const date = new Date(start);
    let remaining = days;
    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) remaining -= 1;
    }
    return date;
  }

  render() {
    const option = this.select.options[this.select.selectedIndex];
    const { min: transit, max: transitMax } = this.transitRange(option);
    const now = this.nowET();
    const cutoff = new Date(now);
    cutoff.setHours(this.cutoffHour, 0, 0, 0);
    const isWeekday = now.getDay() !== 0 && now.getDay() !== 6;
    const shipsToday = isWeekday && now < cutoff;
    const shipDate = shipsToday ? new Date(now) : this.addBusinessDays(now, 1);
    const early = this.addBusinessDays(shipDate, transit);
    const late = this.addBusinessDays(shipDate, transitMax);
    const range = early.getTime() === late.getTime() ? this.fmt(early) : `${this.fmt(early)} – ${this.fmt(late)}`;
    const t = this.dataset;

    this.set('[data-arr-state]', option.textContent);
    this.set('[data-arr-date]', range);
    this.set('[data-tl-order]', t.tToday.replace('[date]', this.fmt(now)));
    this.set(
      '[data-tl-ship]',
      shipsToday
        ? t.tShipToday.replace('[date]', this.fmt(shipDate)).replace('[cutoff]', t.cutoffLabel)
        : t.tShipNext.replace('[date]', this.fmt(shipDate))
    );
    this.set('[data-tl-deliver]', range);
    this.set('[data-trigger-date]', this.fmt(early));

    const cutoffEl = this.querySelector('[data-cutoff-text]');
    if (cutoffEl) {
      if (shipsToday) {
        const ms = cutoff - now;
        const hours = Math.floor(ms / 3600000);
        const minutes = Math.floor((ms % 3600000) / 60000);
        cutoffEl.innerHTML = t.tWithin.replace('[time]', `${hours}h ${minutes}m`).replace('[cutoff]', t.cutoffLabel);
      } else {
        cutoffEl.innerHTML = t.tPassed.replace('[cutoff]', t.cutoffLabel);
      }
    }
  }

  set(selector, text) {
    const el = this.querySelector(selector);
    if (el) el.textContent = text;
  }

  transitRange(option) {
    const fedex = this.parseDays(option.dataset.fedex);
    const ups = this.parseDays(option.dataset.ups);
    if (fedex || ups) {
      const both = [fedex, ups].filter(Boolean);
      return {
        min: Math.min(...both.map((r) => r.min)),
        max: Math.max(...both.map((r) => r.max)),
      };
    }
    const min = parseInt(option.value, 10) || 4;
    const max = parseInt(option.dataset.max, 10) || min + 1;
    return { min, max };
  }

  parseDays(str) {
    if (!str) return null;
    const nums = (str.match(/\d+/g) || []).map(Number);
    if (!nums.length) return null;
    const mult = /week/i.test(str) ? 5 : 1;
    return { min: Math.min(...nums) * mult, max: Math.max(...nums) * mult };
  }
}

customElements.define('delivery-estimate', DeliveryEstimate);
